import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActEconomicasRubrosService } from 'src/app/global/services/act-economicas-rubros.service';


@Injectable()
export class ActEconomicasRubrosProvider extends ActEconomicasRubrosService {

    constructor(private http: HttpClient) {
        super();
    }

    getDatos(): Observable<any> {
        return this.http.get('./assets/rubros.json');
    }
}
